import { PassengerCountPickerType } from "halifax";

interface ITravelers {
  adultsCount: number;
  children: number[];
  infants: { age: number; inSeat: boolean }[];
}

export const getPassengerCounts = (
  pendingTravelerCounts: PassengerCountPickerType | null,
  travelers: ITravelers
) => {
  if (pendingTravelerCounts && "adultsCount" in pendingTravelerCounts) {
    return {
      adultsCount: pendingTravelerCounts.adultsCount,
      children: pendingTravelerCounts.childrenAges || [],
      childrenCount: pendingTravelerCounts.childrenAges?.length || 0,
      infants: pendingTravelerCounts.infants || [],
      infantsInSeatCount: (pendingTravelerCounts.infants || []).filter(
        ({ inSeat }) => inSeat
      ).length,
      infantsOnLapCount: (pendingTravelerCounts.infants || []).filter(
        ({ inSeat }) => !inSeat
      ).length,
    };
  }
  return {
    adultsCount: travelers.adultsCount,
    children: travelers.children,
    childrenCount: travelers.children.length,
    infants: travelers.infants,
    infantsInSeatCount: travelers.infants.filter(({ inSeat }) => inSeat).length,
    infantsOnLapCount: travelers.infants.filter(({ inSeat }) => !inSeat).length,
  };
};
